import { AlertService } from './alert.service'

export class Alert {
    texto: string
    cssClass: string
    titulo: string

    readonly duracao: number | boolean

    private timeout: any
    private service: AlertService

    constructor(
        service: AlertService,
        texto: string,
        titulo?: string,
        tipo: 'warning' | 'danger' | 'success' | 'info' = 'warning',
        duracao: number | boolean = 6
    ) {
        this.service = service

        this.texto = texto
        this.titulo = titulo
        this.duracao = duracao
        this.cssClass = `alert-${tipo}`

        if (typeof duracao === 'number') {
            this.initTimeout(duracao * 1000)
        }
    }

    fechar() {
        clearTimeout(this.timeout)
        this.service.remover(this)
    }

    private initTimeout(timeout: number) {
        if (timeout > 0) {
            this.timeout = setTimeout(() => this.fechar(), timeout)
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/common/alert/shared/alert.model.ts